export { getLanguageAlternates, type PageContext, type PageType } from "./getLanguageAlternates";
